import * as React from "react";
import * as Icons from "@mui/icons-material";
import * as CustomIcons from "./icons";

type IconType = typeof import("@mui/icons-material");
type CustomIconType = typeof import("./icons");

export type DynamicIconProps = {
  iconName: string;
  className?: string;
  onClick?: () => void;
  alt?: string;
  fallback?: string;
  data?: string;
};

export default function DynamicIcon({
  iconName,
  className = "",
  onClick,
  data,
  fallback,
  ...restProps
}: DynamicIconProps) {
  const icon = (CustomIcons[iconName as keyof CustomIconType] ||
    Icons[iconName as keyof IconType]) as React.ElementType | undefined;
  const fallbackIcon = fallback
    ? ((CustomIcons[fallback as keyof CustomIconType] || Icons[fallback as keyof IconType]) as
        | React.ElementType
        | undefined)
    : undefined;

  const params = {
    className,
    onClick,
    "data-testid": data,
    ...restProps,
  };

  if (icon) {
    return React.createElement(icon, params);
  }

  if (fallbackIcon) {
    return React.createElement(fallbackIcon, params);
  }

  return <span {...params}>{iconName}</span>;
}
